import type { FaqCategory } from '@cvo/ui/components';
import { useI18nArray } from '@cvo/i18n/composables/useI18nArray';

interface FaqsLink {
  hasStandalonePage: ComputedRef<boolean>;
  faqsPage: ComputedRef<string>;
  landingAnchor: ComputedRef<string>;
  faqsLink: ComputedRef<string>;
}

export function useFaqsLink(): FaqsLink {
  const faqCategories = useI18nArray<FaqCategory>('custom.faqs.categories');
  const localePath = useLocalePath();
  const { features } = useAppConfig();

  const hasStandalonePage = computed(() => features.faqPage && faqCategories.value.length > 0);
  // localePath is typed as a route location, not a string.
  const faqsPage = computed(() => String(localePath('/faqs')));
  const landingAnchor = computed(() => `${localePath('/')}#faqs`);
  const faqsLink = computed(() => (hasStandalonePage.value ? faqsPage.value : landingAnchor.value));

  return { hasStandalonePage, faqsPage, landingAnchor, faqsLink };
}
